import {
  IBlock,
  IRichText,
  IAsset,
  TextType,
} from "@app/models/storyblok/basic";

export enum IconSize {
  SMALL = "small",
  STANDART = "standart",
}

export type IconBoxData = {
  title: IRichText<TextType>;
  icon: IAsset;
  iconSize: IconSize;
  text?: IRichText<TextType>;
} & IBlock;
